import React, { useEffect, useState } from "react";
import { serverConfig } from "../ApiSearchPath/ApiSearchPath";

const PrintInvoice = ({ data, printWindow }) => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    if (data) {
      const pages = [];
      let currentPageContent = [];
      let currentItemCount = 0;
      let currentPageIndex = 0;

      const getMaxItemsPerPage = () => (currentPageIndex === 0 ? 24 : 28);

      const startNewPage = () => {
        if (currentPageContent.length > 0) {
          pages.push([...currentPageContent]);
          currentPageContent = [];
          currentItemCount = 0;
          currentPageIndex += 1;
        }
      };

      // Header content with image
      const headerContent = `
        <header class="print-header">
          <img
            src="${serverConfig.BASE_URL}/uploads/company/${data.companyHeaderImage || 'default-header.jpg'}"
            alt="Header"
            style="width: 100%; height: 150px; object-fit: fill;" 
            onerror="this.onerror=null; this.src='assets/img/headerCompany.png';"
          />
        </header>
      `;
      currentPageContent.push(headerContent);

      // Patient and Receipt Info
      const patientInfo = `
        <section class="patient-info">
          <table style="width: 100%; border-collapse: collapse; font-size: 11px; margin-bottom: 10px; border: 1px solid #ccc;">
            <tr style="border-bottom: 1px solid #ccc;">
              <td style="padding: 6px;border: 1px solid #ccc;">Receipt No: ${data.receiptNo}</td>
              <td style="padding: 6px;border: 1px solid #ccc;">Patient Id: ${data.patientId}</td>
            </tr>
            <tr style="border-bottom: 1px solid #ccc;">
              <td style="padding: 6px;border: 1px solid #ccc;">Patient Name: ${data.patientName}</td>
              <td style="padding: 6px;border: 1px solid #ccc;">Date: ${new Date(data.reportingDate).toLocaleDateString()} ${data.reportingTime}</td>
            </tr>
            <tr style="border-bottom: 1px solid #ccc;">
              <td style="padding: 6px;border: 1px solid #ccc;">Age: ${data.age}yrs Sex: ${data.gender}</td>
              <td style="padding: 6px;border: 1px solid #ccc;">Email-Id: ${data.emailId || 'N/A'}</td>
            </tr>
            <tr>
              <td style="padding: 6px;border: 1px solid #ccc;">Address: ${data.address}</td>
              <td style="padding: 6px;border: 1px solid #ccc;">Mobile No: ${data.mobileNo}</td>
            </tr>
          </table>
        </section>
      `;
      currentPageContent.push(patientInfo);
      currentItemCount += 4;

      // Test/Treatment Table
      const tableHeader = `
        <table style="width: 100%; border-collapse: collapse;font-size:11px; margin-top: 10px;border: 1px solid #ccc;">
          <thead>
            <tr style="border: 1px solid black;">
              <th style="padding: 5px;border: 1px solid #ccc;">S No.</th>
              <th style="padding: 5px;border: 1px solid #ccc;">${(data?.invType==='Appointment')?`Fee Type`:`Treatments/Tests`}</th>
              <th style="padding: 5px;border: 1px solid #ccc;">Quantity</th>
              <th style="padding: 5px;border: 1px solid #ccc;">Rate</th>
              <th style="padding: 5px;border: 1px solid #ccc;">Amount</th>
            </tr>
          </thead>
          <tbody>
      `;
      currentPageContent.push(tableHeader);

      data.testRows.forEach((row, index) => {
        if (currentItemCount >= getMaxItemsPerPage()) {
          currentPageContent.push("</tbody></table>");
          startNewPage();
          currentPageContent.push(tableHeader);
        }
        const rowContent = `
          <tr style="border: 1px solid black;">
            <td style="padding: 5px;border: 1px solid #ccc;">${index + 1}</td>
            <td style="padding: 5px;border: 1px solid #ccc;">${row.test}</td>
            <td style="padding: 5px;border: 1px solid #ccc;">${row.quantity}</td>
            <td style="padding: 5px;border: 1px solid #ccc;">${row.price}</td>
            <td style="padding: 5px;border: 1px solid #ccc;">${row.quantity*row.price}</td>
          </tr>
        `;
        currentPageContent.push(rowContent);
        currentItemCount += 1;
      });

      currentPageContent.push("</tbody></table>");

      // Totals
//      let discountTd = data.discount > 0
//   ? `<td style="padding: 5px;border: 1px solid #aaa;">Discount: ₹${data.discount}</td>`
//   : "";

// let duesTd = data.dues > 0
//   ? `<td style="padding: 5px;border: 1px solid #aaa;">Dues: ₹${data.dues}</td>`
//   : "";

// const totalsContent = `
//   <table style="width: 100%; border-collapse: collapse; font-size: 11px; margin-top: 10px; border: 1px solid #aaa;">
//     <tr style="border: 1px solid black;">
//       //${discountTd}
//       <td style="padding: 5px;border: 1px solid #aaa;">Total Amount: ₹${data.paidAmount}</td>
//       //<td style="padding: 5px;border: 1px solid #aaa;">Paid Amount: ₹${data.paidAmount}</td>
//       //${duesTd}
//       //<td style="padding: 5px;border: 1px solid #aaa;">Total Amount: ₹${data.totalAmount}</td>
//     </tr>
//   </table>
// `;
const totalsContent = `
  <table style="width: 100%; border-collapse: collapse; font-size: 11px; margin-top: 10px; border: 1px solid #aaa;">
    <tr style="border: 1px solid black;">
      <td style="padding: 5px;border: 1px solid #aaa;text-align:right;">Total paid: ₹${data.paidAmount}</td>
    </tr>
  </table>
`;

      currentPageContent.push(totalsContent);

      const signature=`
        <table style="width: 100%; border-collapse: collapse;
        font-size:13px;color:red; margin-top: 10px;
        border: 1px solid #aaa;
        ">
          <tr style="border: 1px solid black;">
            <td style="padding: 5px;border: 1px solid #aaa;padding-right:200px;
        padding-top:70px;text-align:right;"><b>Signature:</b> </td>
          </tr>
        </table>
      `;

      currentPageContent.push(signature);
     

      if (currentPageContent.length > 0) {
        pages.push(currentPageContent);
      }

      setPages(pages);
    }
  }, [data]);

  // Trigger automatic print
  useEffect(() => {
    if (pages.length > 0 && printWindow) {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }, 500); // Delay to ensure rendering is complete
    }
  }, [pages, printWindow]);

  if (!data) return <div>Loading...</div>;

  return (
    <>
      <style>
        {`
        .print-page {
          width: 800px;
          margin: 0;
          position: relative;
          font-family: 'Segoe UI', sans-serif;
          page-break-after: always;
        }
        .print-header, .print-footer {
          width: 100%;
          height: 150px;
          background-color: white;
          border-top: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
        }
        .print-body {
          padding: 20px;
          position: relative;
          background-color: white;
        }
        .patient-info {
          margin-bottom: 20px;
        }
        @media print {
          body { margin: 0; }
          .print-page { page-break-after: always; position: relative; }
          .print-header { position: fixed; top: 0; height: 150px; width: 100%; }
          .print-footer { position: fixed; bottom: 0; height: 150px; width: 100%; }
          .print-body { margin-top: 150px; margin-bottom: 150px; padding: 20px; page-break-inside: auto; }
        }
        `}
      </style>
      {pages.map((pageContent, pageIndex) => (
        <div key={pageIndex} className="print-page">
          <main className="print-body">
            <div dangerouslySetInnerHTML={{ __html: pageContent.join("") }} />
          </main>
        </div>
      ))}
    </>
  );
};

export default PrintInvoice;